import React from 'react'
import { cn } from 'src/lib/utils'

interface DividerProps {
  className?: string
}

export const Divider = ({ className }: DividerProps): React.ReactElement => {
  return <hr className={cn('border-t border-tertiary-grey', className)} />
}
